/*
  POUFF → Klaviyo newsletter subscribe.

  Progressive enhancement for any form marked with [data-pouff-klaviyo-form]:
  intercepts submit and subscribes the email to a Klaviyo list client-side,
  instead of navigating away to Klaviyo's generic hosted subscribe page.

  Uses Klaviyo's PUBLIC API key (site ID) only — never a private key. This
  endpoint is explicitly designed for browser use, so the key being visible
  in markup is expected, not a leak.

  Verified against Klaviyo's OpenAPI spec (create_client_subscription):
    POST https://a.klaviyo.com/client/subscriptions?company_id=<public key>
    headers: revision (required), Content-Type: application/vnd.api+json
    body:    data.type "subscription", attributes.profile.data.type "profile",
             relationships.list.data { type: "list", id: <list id> }
    success: 202 Accepted, empty body

  A single delegated listener on `document` handles every form on the page, so
  this file is safe to include from more than one section — the guard below
  keeps it bound exactly once.
*/
(function () {
  if (window.__pouffKlaviyoBound) return;
  window.__pouffKlaviyoBound = true;

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var REVISION = '2026-07-15';
  var ERROR_TEXT = "That didn't go through. Try again in a moment.";

  function setStatus(form, message, isError) {
    var el = form.querySelector('[data-pouff-klaviyo-status]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
    el.setAttribute('role', isError ? 'alert' : 'status');
    if (isError) {
      el.setAttribute('data-pouff-klaviyo-error', '');
    } else {
      el.removeAttribute('data-pouff-klaviyo-error');
    }
  }

  function subscribe(form) {
    var companyId = form.getAttribute('data-pouff-klaviyo-company');
    var listId = form.getAttribute('data-pouff-klaviyo-list');
    var input = form.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : '';

    // Missing config would silently 4XX — fall back to letting the browser
    // submit the form normally rather than swallowing the signup.
    if (!companyId || !listId) return false;
    if (!email) return true;

    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    setStatus(form, '', false);

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source:
              form.getAttribute('data-pouff-klaviyo-source') || 'POUFF site',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    })
      .then(function (response) {
        if (response.status === 202) {
          if (input) input.value = '';
          setStatus(
            form,
            form.getAttribute('data-pouff-klaviyo-success') ||
              "You're in. See you out there.",
            false
          );
        } else {
          setStatus(form, ERROR_TEXT, true);
        }
      })
      .catch(function () {
        setStatus(form, ERROR_TEXT, true);
      })
      .then(function () {
        if (button) button.disabled = false;
      });

    return true;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-pouff-klaviyo-form]');
    if (!form) return;
    if (subscribe(form)) event.preventDefault();
  });
})();
